import { render } from "./AppTabsV2.vue?vue&type=template&id=5d4b50d9&scoped=true"
import script from "./AppTabsV2.vue?vue&type=script&lang=js"
export * from "./AppTabsV2.vue?vue&type=script&lang=js"

import "./AppTabsV2.vue?vue&type=style&index=0&id=5d4b50d9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4b50d9"]])

export default __exports__